var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-reader btn btn-outline-secondary"},[_vm._t("default"),_c('input',{attrs:{"type":"file"},on:{"change":_vm.loadTextFromFile}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }